const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '7×24小时全网追踪，热点事件发生后第一时间上线内容。51黑料吃瓜网拥有专业的编辑团队和智能抓取系统，确保51吃瓜在线观看的用户永远快人一步，不会错过任何一个重要瓜。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '高清流畅',
    desc: '采用先进的视频分发与CDN加速技术，无论你是在WiFi还是移动网络环境下使用51黑料在线观看，都能享受高清流畅的播放体验。黑料在线播放画质清晰，加载迅速。',
  },
  {
    icon: 'ri-global-line',
    title: '全网最全',
    desc: '覆盖娱乐圈、网红圈、综艺、影视、音乐、直播、社会热点等七大领域，吃瓜在线视频资源超过5000+条。无论是51吃瓜在线观看还是黑料在线播放，这里都有你最想看的内容。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            为什么数百万吃瓜群众选择51黑料吃瓜网
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, i) => (
            <div key={i} className="text-center group">
              <div className="w-16 h-16 md:w-18 md:h-18 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-2xl md:text-3xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}